import React from "react";
import BlurbImage from "../../../Assets/Images/sports-rec-2.png";
import BlurbImage1 from "../../../Assets/Images/Football.png";
import BlurbImage3 from "../../../Assets/Images/Football(1).png";
import BlurbImag4 from "../../../Assets/Images/Football(2).png";
import { SCHOOL_PROGRAM_PDF } from "../../../Constants/mediaLinks";

import "./blurbs.css";

const Blurbs = () => {
  return (
    <div className="sp-blurbs">
      <p className="black-text-clip">
        BWC is a licensed DOE vendor with over 5 years of experience working
        within the NYC school system. We have served thousands of students each
        in both public and private schools, our DOE Vendor is #BEC214306.
      </p>
      <div className="sp-blurbs-list">
        <div className="sp-blurb-item">
          <span className="black-text-clip">Recess</span>
          <img src={BlurbImage1} alt="BlurbImage" />
        </div>
        <div className="sp-blurb-item">
          <span className="black-text-clip">Sports & Rec Day</span>
          <img src={BlurbImage} alt="BlurbImage" />
        </div>
        <div className="sp-blurb-item">
          <span className="black-text-clip">Fun Day</span>
          <img src={BlurbImage3} alt="BlurbImage" />
        </div>
        <div className="sp-blurb-item">
          <span className="black-text-clip">Skills & Drills</span>
          <img src={BlurbImag4} alt="BlurbImage" />
        </div>
      </div>
      <button
        className="sp-blurb-btn"
        style={{ backgroundColor: "#C7822D" }}
        onClick={() => window.open(SCHOOL_PROGRAM_PDF, "_blank")}
      >
        Download School Programs PDF
      </button>
    </div>
  );
};
export default Blurbs;
